<video oncontextmenu="return false;" #videoElement>
  <source [src]="videoPath()" type="video/mp4" />
  Movie type not supported
</video>
